import React from "react";
import UserInfo from "./UserInfo";
import MinifyMenu from "./MinifyMenu";
import Menu from "./Menu";

const Navigation = () => {
  return (
    <aside id="left-panel">
      <UserInfo />
      <nav>
        <Menu
          openedSign={'<i class="fa fa-minus-square-o"></i>'}
          closedSign={'<i class="fa fa-plus-square-o"></i>'}
        />
      </nav>
      <MinifyMenu />
    </aside>
  );
};

export default Navigation;
